import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import { BADGES_PER_PRODUCT_BY_COUNTRY, BADGES_COUNTRIES } from "segments/desktop/grid/layouts/badges-grid/badges-const";
import { WORK_MANAGEMENT_PRODUCT_ID } from "constants/products";
import withResponsiveHOC from "components/enhancements/responsive-hoc/responsive-hoc-component";
import BadgesGridDesktopComponent from "./components/badges-grid-desktop/badges-grid-desktop-component";
import BadgesGridMobileComponent from "./components/badges-grid-mobile/badges-grid-mobile-component";
const BadgesGridComponent = ({ product, country, horizontalPadding })=>{
    const badges = useMemo(()=>{
        var _BADGES_PER_PRODUCT_BY_COUNTRY_product, _BADGES_PER_PRODUCT_BY_COUNTRY_product1;
        return ((_BADGES_PER_PRODUCT_BY_COUNTRY_product = BADGES_PER_PRODUCT_BY_COUNTRY[product]) === null || _BADGES_PER_PRODUCT_BY_COUNTRY_product === void 0 ? void 0 : _BADGES_PER_PRODUCT_BY_COUNTRY_product[country]) || ((_BADGES_PER_PRODUCT_BY_COUNTRY_product1 = BADGES_PER_PRODUCT_BY_COUNTRY[product]) === null || _BADGES_PER_PRODUCT_BY_COUNTRY_product1 === void 0 ? void 0 : _BADGES_PER_PRODUCT_BY_COUNTRY_product1[BADGES_COUNTRIES.GENERAL]) || BADGES_PER_PRODUCT_BY_COUNTRY[WORK_MANAGEMENT_PRODUCT_ID][BADGES_COUNTRIES.GENERAL];
    }, [
        product
    ]);
    const BadgesResponsiveComponent = useMemo(()=>withResponsiveHOC(BadgesGridDesktopComponent, BadgesGridMobileComponent), []);
    return /*#__PURE__*/ _jsx(BadgesResponsiveComponent, {
        badges: badges,
        horizontalPadding: horizontalPadding
    });
};
export default BadgesGridComponent;
